import { Account } from '../models/account-management/account';

export class AccountSaveResult {
    public success: boolean;
    public account: Account;
    public successMsg: string;
    public errorMsg: string;
    public errorField: string;
    public accountCreationToken: string;
}